import { repositoryActions } from '../../services';

function indexOf( itemArray, item, predicate ) {
  let value = predicate( item );
  for ( let i = 0; i < itemArray.length; i++ ) {
    if ( predicate( itemArray[i] ) === value ) {
      return i;
    }
  }
  return -1;
}

export const repositoryReducer = ( entityName, predicate = i => i.id ) => ( state = { items: [] }, action ) => {
  let index;
  switch ( action.type ) {
    case repositoryActions( entityName ).SET:
      index = indexOf( state.items, action.item, predicate );
      return index === -1 ? { ...state, items: [...state.items, action.item] } : { ...state, items: [...state.items.slice( 0, index ), action.item, ...state.items.slice( index + 1 )] };
    case repositoryActions( entityName ).RETRIEVED:
      return { ...state, items: action.items };
    case repositoryActions( entityName ).DELETED:
      index = indexOf( state.items, action.item, predicate );
      return index === -1 ? state : { ...state, items: [...state.items.slice( 0, index ), ...state.items.slice( index + 1 )] };
    case repositoryActions( entityName ).CLEAR:
      return { items: [] };
    default:
      return state;
  }
};